import Axios from 'axios'
import Vue from 'vue'

import BasePositionObject from "./helpers/basePositionObject"
import { stateMerge } from "vue-object-merge"

const PositionStore = {
    namespaced: true,
    state: {
        currentPosition: {},
        currentEvalsList: [],
        associatedRefType: null,
        associatedCat: {},
        associatedRef: {},
        formValidity: [],
        formCurrentStep: 0,
        formStepsName: [],
        positionsList: [],
        currentPage: 1,
        totalPages: 0,
        itemPerPage: 0,
        candidatesCurrentPage: 1,
        candidatesTotalPages: 0,
        candidatesItemPerPage: 0,
        sortColumn: 'created_at',
        sortType: 'desc',
        searchQuery: null,
        PositionEvals: []
    },
    getters: {
        searchPositions: (state) => (query) =>{
            if(query != ""){
                return state.positionsList.filter( (position) => {
                    return position.name.toLowerCase().includes( query.toLowerCase() )
                });
            }else{
                return []
            }
        }
    },
    mutations: {
        initNew(state){
            state.currentEvalsList = []
            state.currentPosition = BasePositionObject()
            state.formValidity = [false, false, false, false, false]
            state.formStepsName = ["FormStep1", "FormStep2", "FormStep3", "FormStep4", "FormStep5", "FormStep6"]
            state.formCurrentStep = 0
        },
        updatePositionData(state, positionData){
            stateMerge(state.currentPosition, positionData)
        },
        updateFormValidity(state, validityData){
            Vue.set(state.formValidity, validityData.index, validityData.validity)
        },
        changeCurrentStep(state, formData){
            state.formCurrentStep = formData.index
        },
        setAssociatedObjects(state, associatedData){
            state.associatedRef = associatedData.associatedRef
            state.associatedCat = associatedData.associatedCat
            state.associatedRefType = associatedData.associatedRefType
        },
        addToEvalsList(state, evalItem){
            state.currentEvalsList.unshift(evalItem)
        },
        setEvalList(state, evalList){
            state.currentEvalsList = evalList
        },
        removeFromEvalsList(state, evalItem){
            const index = state.currentEvalsList.findIndex(evaluation => evaluation.id === evalItem.id)
            if(index > -1){
                Vue.delete(state.currentEvalsList, index)
            }
        },
        indexPositions(state, resp){
            if (resp.meta){
                state.totalPages = resp.meta.total_pages
                state.currentPage = resp.meta.current_page
                state.itemPerPage = resp.meta.item_per_page
                state.searchQuery = resp.meta.search_query
                state.sortColumn = resp.meta.sort_column
                state.sortType = resp.meta.sort_type
            }
            state.positionsList = resp.sight_groups
        },
        getPosition(state, position){
            state.currentPosition = position
        },
        initEdit(state, position){
            state.currentEvalsList = []
            state.currentPosition = position
            
            state.associatedRef = position.sight_ref
            state.associatedCat = position.sight_ref_cat
            state.formValidity = [true, true, true, true]
            state.formStepsName = ["FormStep1", "FormStep2", "FormStep4", "FormStep5"]
            state.formCurrentStep = 0
        },
        indexPositionEvals(state, data){
            state.PositionEvals = data.evaluations
            state.candidatesCurrentPage = data.meta.current_page
            state.candidatesTotalPages = data.meta.total_pages
            state.candidatesItemPerPage = data.meta.item_per_page
        }
    },
    actions: {
        initNew: initNew,
        createPosition: createPosition,
        indexPositions: indexPositions,
        getPosition: getPosition,
        updatePosition: updatePosition,
        deletePosition: deletePosition,
        initEdit: initEdit,
        sendReportsEmails: sendReportsEmails,
        getPositionEvals: getPositionEvals
    }
}

function sendReportsEmails(context, emailData){
    return Axios.post(this.sightApiBaseUrl + "sight_groups/" + emailData.sight_group_id + '/send_reports', emailData)
    .then(resp => {
        return resp.data
    })
    .catch(err => {
        console.log("PositionsStore/Send report error", err.response)
        return err.response
    })
}

function initEdit(context, positionId){
    Axios.get(this.sightApiBaseUrl + "sight_groups/" + positionId + '/edit' )
    .then(resp => {
        context.commit('initEdit', resp.data)
    })
    .catch(err => {
        console.log("RefsStore/Index error", err)
    })
}

function deletePosition(context, position){
    return Axios.delete(this.sightApiBaseUrl + "sight_groups/" + position.id )
    .then(resp => {
        return resp
    })
    .catch(err => {
        console.log("PositionStore/Delete error", err)
    })
}

function updatePosition(context){
    const params = {
        sight_group: context.state.currentPosition,
        evaluations: context.state.currentEvalsList,
    }
    params.sight_group['sight_ref_id'] = context.state.associatedRef.id

    return Axios.put(this.sightApiBaseUrl + "sight_groups/" + params.sight_group.id, params)
    .then(resp => {
        return resp.data
    })
    .catch(err => {
        console.log("PositionsStore/Update error", err)
    })
}

function getPosition(context, positionId){
    return Axios.get(this.sightApiBaseUrl + "sight_groups/" + positionId + "/edit")
    .then(resp => {
        context.commit('getPosition', resp.data)
        return resp.data
    })
    .catch(err => {
        console.log("PositionsStore/Index error", err)
    })
}

function indexPositions(context, params){
    const data = {
        sort_column: params.sort_column ? params.sort_column : context.state.sortColumn,
        sort_type: params.sort_type ? params.sort_type : context.state.sortType,
        page: params.page ? params.page : context.state.currentPage,
        search_query: (params.search_query != null) ? params.search_query : context.state.searchQuery
    }
    Axios.get(this.sightApiBaseUrl + "sight_groups", {
        params: data
    }).then(resp => {
        context.commit('indexPositions', resp.data)
    })
    .catch(err => {
        console.log("PositionsStore/Index error", err)
    })
}

function createPosition(context){
    const params = {
        sight_group: context.state.currentPosition,
        evaluations: context.state.currentEvalsList,
    }
    params.sight_group['sight_ref_id'] = context.state.associatedRef.id

    return Axios.post(this.sightApiBaseUrl + "sight_groups", params).then(resp => {
        return resp.data
        // context.commit('updateEvalData', resp.data)
    }).catch(err => {
        console.log("RefsStore/Index error", err.response)
    })
}

function initNew(context){
    context.commit('initNew')
}

function getPositionEvals(context, query_data){
    const data = {
        position_id: query_data.position_id,
        sort_column: query_data.sort_column ? query_data.sort_column : 0,
        sort_type: query_data.sort_type ? query_data.sort_type : 0,
        only_completed: query_data.only_completed ? query_data.only_completed : 0,
        page: query_data.current_page ? query_data.current_page : 0,
        limit: query_data.item_per_page ? query_data.item_per_page : 0,
    }
    Axios.get(this.sightApiBaseUrl + "/sight_groups/" + data.position_id + "/get_sight_group_evals", {
        params: data
    }).then(resp => {
        context.commit('indexPositionEvals', resp.data)
    })
    .catch(err => {
        console.log("PositionsStore/Index evals error", err)
    })
}

export default PositionStore